export function showToast(message, type = 'success') {
    const toast = document.getElementById('toast');

    // Remove any previous type classes
    toast.classList.remove('bg-green-800', 'bg-red-800', 'hidden', 'opacity-0', 'translate-x-10');

    // Set new styles based on type
    if (type === 'success') {
        toast.classList.add('bg-green-800');
    } else if (type === 'error') {
        toast.classList.add('bg-red-800');
    }

    toast.textContent = message;

    // Show with transition
    toast.classList.remove('opacity-0', 'translate-x-10');
    toast.classList.add('opacity-100', 'translate-x-0');

    // Display it
    toast.classList.remove('hidden');

    // Hide after 4 seconds
    setTimeout(() => {
        toast.classList.add('opacity-0', 'translate-x-10');
        toast.classList.remove('opacity-100');

        setTimeout(() => {
            toast.classList.add('hidden');
        }, 500); // match transition duration
    }, 4000);
}